
// ====== 设计稿基准配置 ======
// 移动端设计稿宽度（一般按 750 / 768 设计）
const DESIGN_MOBILE = 768;

// 平板端设计稿宽度（作为平板到 PC 的过渡区间）
const DESIGN_TABLET = 1255;

// rem 计算基准值（1rem = BASE_FONT px）
const BASE_FONT = 10;

// PC 端固定根字号
const PC_FONT = 16;

// 上一次生效的视口宽度，用于过滤掉「只有高度变化」的 resize
let lastWidth = -1;

/**
 * 根据当前视口宽度计算根字体大小
 * 规则：
 * 1. PC 端（>1255）：固定 16px，防止过大
 * 2. 平板端（769 ~ 1255）：按平板设计稿等比缩放，下限 12px
 * 3. 移动端（<=768）：按手机设计稿等比缩放，下限 8px
 * @param force 忽略宽度未变化判断，强制重算（首次初始化时使用）
 */
const applyRem = (force = false) => {
  // 与 SCSS 媒体查询保持同一口径：window.innerWidth 是含滚动条的视口宽度
  const width = window.innerWidth;

  // 宽度没变就什么都不做，避免滚动、地址栏收放引起的无意义重算
  if (!force && width === lastWidth) return;
  lastWidth = width;

  let fontSize;

  if (width > DESIGN_TABLET) {
    // PC 端
    fontSize = PC_FONT;
  } else if (width > DESIGN_MOBILE) {
    // 平板端：按设计稿比例计算，并保证不小于 12px
    fontSize = Math.max((width / DESIGN_TABLET) * BASE_FONT, 12);
  } else {
    // 移动端：按设计稿比例计算，并保证不小于 8px
    fontSize = Math.max((width / DESIGN_MOBILE) * BASE_FONT, 8);
  }

  document.documentElement.style.fontSize = fontSize + 'px';
};


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => applyRem(true), { once: true });
} else {
  applyRem(true);
}

// ====== 尺寸变化时重算（防抖） ======
let timer: number | undefined;

/**
 * 防抖，避免 resize / orientationchange 高频触发导致性能问题
 */
const onResize = () => {
  window.clearTimeout(timer);
  timer = window.setTimeout(() => applyRem(), 150);
};

window.addEventListener('resize', onResize);
// 移动端横竖屏切换时重新计算
window.addEventListener('orientationchange', onResize);
